import {
  Circle,
  Download,
  File,
  FileText,
  Truck,
  User,
  ShoppingBag,
  Clock,
  Trello,
  Bell,
  Shuffle,
  Pocket,
  Users,
  Anchor
} from "react-feather";

export default [
  {
    id: "dashboard",
    title: "表現",
    icon: <Trello size={20} />,
    children: [
      {
        id: "order-performance",
        title: "訂單儀表版",
        icon: <Circle size={12} />,
        navLink: "/dashboard/order",
      },
      {
        id: "driver-performance",
        title: "司機儀表版",
        icon: <Circle size={12} />,
        navLink: "/dashboard/driver-dashboard",
      },
      {
        id: "driver-att-performance",
        title: "考勤儀表版",
        icon: <Circle size={12} />,
        navLink: "/dashboard/attendance-dashboard",
      },
      {
        id: "order-monitoring",
        title: "追蹤柯打儀表版",
        icon: <Circle size={12} />,
        navLink: "/dashboard/monitor-order-dashboard",
      },
      {
        id: "contract-monitoring",
        title: "合約儀表版",
        icon: <Circle size={12} />,
        navLink: "/dashboard/contract",
      }
    ],
  },
  {
    id: "driver",
    title: "司機",
    icon: <Truck size={20} />,
    children: [
      {
        id: "driver-list",
        title: "司機列表",
        icon: <Circle size={12} />,
        navLink: "/driver/list",
      },
      {
        id: "vehicle-list",
        title: "車輛列表",
        icon: <Circle size={12} />,
        navLink: "/driver/vehicle",
      },
      {
        id: "order-import",
        title: "匯入司機",
        icon: <Circle size={12} />,
        navLink: "/driver/import",
      },
      {
        id: "driver-location",
        title: "司機位置",
        icon: <Circle size={12} />,
        navLink: "/driver/location",
      },
      {
        id: "traffic-ticket-list",
        title: "告票",
        icon: <Circle size={12} />,
        navLink: "/driver/ticket",
      },
      {
        id: "incident-report-list",
        title: "意外報告",
        icon: <Circle size={12} />,
        navLink: "/driver/incident-report-list",
      },
      {
        id: "chat",
        title: "司機對話",
        icon: <Circle size={12} />,
        navLink: "/driver/chat",
      },
    ],
  },
  {
    id: "user",
    title: "用戶",
    icon: <User size={20} />,
    children: [
      {
        id: "admin-list",
        title: "管理員列表",
        icon: <Circle size={12} />,
        navLink: "/admin/list",
      },
      {
        id: "project-code-list",
        title: "項目列表",
        icon: <Circle size={12} />,
        navLink: "/admin/project-code",
      },
      {
        id: "inbox-message-list",
        title: "訊息列表",
        icon: <Circle size={12} />,
        navLink: "/admin/inbox-message-list",
      },
      {
        id: "permission-management",
        title: "權限管理",
        icon: <Circle size={12} />,
        navLink: "/driver/permission-management",
      },
      {
        id: "no-avatar-dirver-list",
        title: "未上傳照片的司機",
        icon: <Circle size={12} />,
        navLink: "/admin/no-avatar-dirver-list",
      },
    ],
  },
  {
    id: "project",
    title: "項目",
    icon: <File size={20} />,
    children: [
      {
        id: "project-list",
        title: "項目列表",
        icon: <Circle size={12} />,
        navLink: "/project/list",
      },
      {
        id: "project-rate-card",
        title: "項目Rate Card",
        icon: <Circle size={12} />,
        navLink: "/project/rate-card",
      }
    ],
  },
  {
    id: "routes",
    title: "線路",
    icon: <Shuffle size={20} />,
    children: [
      {
        id: "routes-list",
        title: "線路列表",
        icon: <Circle size={12} />,
        navLink: "/routes/list",
      },
      {
        id: "routes-district-list",
        title: "地區送貨日",
        icon: <Circle size={12} />,
        navLink: "/routes/list-district-weekdays",
      },
      {
        id: "routes-address-list",
        title: "地址列表",
        icon: <Circle size={12} />,
        navLink: "/routes/address-list/",
      }
    ],
  },
  {
    id: "order",
    title: "訂單",
    icon: <FileText size={20} />,
    children: [
      {
        id: "process-address",
        title: "地址處理",
        icon: <Circle size={12} />,
        navLink: "/order/process-address",
      },
      {
        id: "order-import",
        title: "匯入訂單",
        icon: <Circle size={12} />,
        navLink: "/order/import",
      },
      {
        id: "list",
        title: "訂單列表",
        icon: <Circle size={12} />,
        navLink: "/order/list",
      },
      {
        id: "list-location",
        title: "訂單位置",
        icon: <Circle size={12} />,
        navLink: "/order/location",
      },
      {
        id: "reassign-history",
        title: "轉單紀錄",
        icon: <Circle size={12} />,
        navLink: "/order/reassign-history",
      },
      {
        id: "hschan-cbf",
        title: "特選客戶CBF處理",
        icon: <Circle size={12} />,
        navLink: "/order/hschan-cbf",
      },
      {
        id: "hschan-route",
        title: "特選客戶車線",
        icon: <Circle size={12} />,
        navLink: "/order/hschan-route",
      },
      {
        id: "customer-record",
        title: "客人紀錄",
        icon: <Circle size={12} />,
        navLink: "/order/customer-record",
      },
    ],
  },
  {
    id: "customer-order",
    title: "客戶",
    icon: <ShoppingBag size={20} />,
    children: [
      {
        id: "list",
        title: "訂單列表",
        icon: <Circle size={12} />,
        navLink: "/customer-order/list",
      },
    ],
  },
  {
    id: "report",
    title: "報告",
    icon: <Download size={20} />,
    children: [
      {
        id: "download-report",
        title: "下載報告",
        icon: <Circle size={12} />,
        navLink: "/report/download-report",
      },
    ],
  },
  {
    id: "attendance",
    title: "出勤",
    icon: <Clock size={20} />,
    children: [
      {
        id: "attendance-record",
        title: "出勤記錄",
        icon: <Circle size={12} />,
        navLink: "/attendance/record",
      },
      {
        id: "attendance-schedule",
        title: "出勤員工資料",
        icon: <Circle size={12} />,
        navLink: "/attendance/schedule",
      },
      {
        id: "attendance-schedule-import",
        title: "匯入時間表",
        icon: <Circle size={12} />,
        navLink: "/attendance/import",
      },
      {
        id: "attendance-group",
        title: "考勤組管理",
        icon: <Circle size={12} />,
        navLink: "/attendance/group",
      },
      {
        id: "attendance-report",
        title: "考勤報告下載",
        icon: <Circle size={12} />,
        navLink: "/attendance/report",
      },
      {
        id: "attendance-supplement",
        title: "補打卡申請",
        icon: <Circle size={12} />,
        navLink: "/attendance/supplement",
      },
      {
        id: "attendance-leave",
        title: "請假申請",
        icon: <Circle size={12} />,
        navLink: "/attendance/leave",
      }
    ],
  },
  {
    id: "staff",
    title: "員工",
    icon: <Users size={20} />,
    children: [
      {
        id: "staff-list",
        title: "員工列表",
        icon: <Circle size={12} />,
        navLink: "/staff/list",
      },
      {
        id: "staff-position",
        title: "職位",
        icon: <Circle size={12} />,
        navLink: "/staff/position",
      },
      {
        id: "staff-department",
        title: "部門",
        icon: <Circle size={12} />,
        navLink: "/staff/department",
      },
      {
        id: "opinion-list",
        title: "員工意見",
        icon: <Circle size={12} />,
        navLink: "/staff/opinion-list",
      }
    ],
  },
  {
    id: "announcement",
    title: "通告",
    icon: <Bell size={20} />,
    children: [
      {
        id: "announcement-list",
        title: "通告列表",
        icon: <Circle size={12} />,
        navLink: "/announcement/announcement-list",
      },
      {
        id: "announcement-handbook",
        title: "員工手冊",
        icon: <Circle size={12} />,
        navLink: "/announcement/handbook",
      },
      {
        id: "term-and-condition",
        title: "條款及細則",
        icon: <Circle size={12} />,
        navLink: "/announcement/termCondition",
      },
      // {
      //   id: "vote",
      //   title: "投票",
      //   icon: <Circle size={12} />,
      //   navLink: "/vote/list",
      // }
    ],
  },
  {
    id: "red-pocket",
    title: "搶紅包",
    icon: <Pocket size={20} />,
    children: [
      {
        id: "red-pocket-redeem",
        title: "兌換紅包",
        icon: <Circle size={12} />,
        navLink: "/redPocket/redeem",
      },
    ],
  },
  {
    id: "survey",
    title: "問卷",
    icon: <Pocket size={20} />,
    children: [
      {
        id: "survey-create",
        title: "製作問卷",
        icon: <Circle size={12} />,
        navLink: "/survey/create",
      },

      {
        id: "survey-list",
        title: "問卷列表",
        icon: <Circle size={12} />,
        navLink: "/survey/list",
      },
      // {
      //   id: "survey-test",
      //   title: "參考問卷",
      //   icon: <Circle size={12} />,
      //   navLink: "/survey/ref",
      // }
    ]
  },
  // {
  //   id: "contract",
  //   title: "合約",
  //   icon: <Anchor size={20} />,
  //   children: [
  //     {
  //       id: "contract-list",
  //       title: "合約列表",
  //       icon: <Circle size={12} />,
  //       navLink: "/contract/list-contract",
  //     },
  //   ],
  // },
];
